import { generateKey } from 'constants/helper';

import {
  ADD_TO_AGENDA_QUEUE,
  DISABLE_AGENDA_QUEUE,
  ENABLE_AGENDA_QUEUE,
  REMOVE_FROM_AGENDA_QUEUE,
} from './actionTypes';

/*
  1. for tagged/linked agendas
    a. we get valid uuid and labelType. 
    b. isTagged is true and text is be empty string
  2. for untagged/normal agenda
    a. uuid is randomly generated id ( so that it can be removed)
    b. isTagged is false
    c. text is non empty
    d. labelType is null
*/
export function addToAgendaQueueAction({
  labelType = null,
  uuid = null,
  text = '',
  isTagged = true,
  levelUpInfo = null,
}) {
  return (dispatch, getState) => {
    const { addToAgendaState } = getState();

    if (addToAgendaState.agendaQueue.findIndex((elem) => elem.uuid === uuid) > -1) {
      return;
    }

    dispatch({
      type: ADD_TO_AGENDA_QUEUE,
      payload: {
        labelType,
        uuid: isTagged ? uuid : generateKey(7),
        text,
        isTagged,
        levelUpInfo,
      },
    });
  };
}

export function removeFromAgendaQueueAction({ uuid }) {
  return (dispatch) => {
    dispatch({
      type: REMOVE_FROM_AGENDA_QUEUE,
      payload: { uuid },
    });
  };
}

export function enableAgendaQueueAction() {
  return (dispatch) => {
    dispatch({
      type: ENABLE_AGENDA_QUEUE,
      payload: null,
    });
  };
}

export function disableAgendaQueueAction() {
  return (dispatch) => {
    dispatch({
      type: DISABLE_AGENDA_QUEUE,
      payload: null,
    });
  };
}
